"use client";
import { Box, Button, Grid, Link, Typography } from "@mui/material";
import FormTextFieldSimple from "../formulari/FormTextFieldSimple";
import { pxToVw } from "@/utils/pxToVw";
import { getTextWithContext, useText, useTexts } from "@/context/TextContext";
import { useActionState, useEffect, useState } from "react";
import { recoverPasswordSchema } from "@/lib/schemas/login";
import z from "zod";
import FormWrapper from "../FormWrapper";
import { recoverPasswordAction } from "@/app/actions";

export default function RecoverForm() {
  const [email, setEmail] = useState("");
  const [errors, setErrors] = useState({} as any);
  const [state, formAction, pending] = useActionState(recoverPasswordAction, {
    errors: undefined,
  });

  const context = useTexts();

  const validateField = () => {
    const result = recoverPasswordSchema
          .partial()
          .safeParse({ email: email || undefined });
        if (!result.success) {
          setErrors(z.treeifyError(result.error).properties);
        } else {
          setErrors({});
        }
  }

  const handleChange = (value: any) => {
    setEmail(value);
   
  };

  useEffect(() => {
    if (state?.errors) {
      setErrors(state.errors);
    }else{
      setErrors({});
    }
  }, [state]);

  return (
    <Grid size={{ xs: 12, md: 5.5 }}>
      <Typography variant="body5" color="warm2" mb={pxToVw(52)}>
        {useText("recoverPassword.subtitle")}
      </Typography>
      <FormWrapper
        errors={errors}
        success={
          state?.success
            ? getTextWithContext("recoverPassword.success", context)
            : undefined
        }
        action={formAction}
        pending={pending}
      >
        <Box mb={pxToVw(53)}>
          <FormTextFieldSimple
            name="email"
            startAdornmentText={useText("login.form.emailLabel")}
            autoComplete="email"
            value={email}
            onBlur={() => validateField()}
            onChange={(e) => handleChange(e.target.value)}
            error={!!errors.email}
            helperText={
              errors.email
                ? errors.email.errors[1]
                  ? getTextWithContext(errors.email.errors[1], context)
                  : getTextWithContext(errors.email.errors[0], context)
                : ""
            }
          />
        </Box>
        <Typography variant="body5" color="warm2" mb={pxToVw(73)}>
          {useText("recoverPassword.contactInfo")}{" "}
          <Link variant="body5" color="marron" href="#">
            {useText("recoverPassword.contactLink")}
          </Link>
        </Typography>

        <Grid container>
          <Button
            variant="botonMarron"
            href={"/login"}
            id="button-recover-volver"
            sx={{ mr: pxToVw(19) }}
          >
            {useText("recoverPassword.backButton")}
          </Button>
          <Button
            variant="botonMarronInverso"
            id="button-recover-enviar"
            type="submit"
          >
            {useText("recoverPassword.sendButton")}
          </Button>
        </Grid>
      </FormWrapper>
    </Grid>
  );
}
